import { render } from "./View652.vue?vue&type=template&id=cc837854"
import script from "./View652.vue?vue&type=script&lang=js"
export * from "./View652.vue?vue&type=script&lang=js"

import "./View652.vue?vue&type=style&index=0&id=cc837854&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__